// Auto generated file, do not manually modify!
// com.hotpads.leasing.client.enums.UserVerificationFailedReason

export enum UserVerificationFailedReason {
  BAD_TOKEN = 'BAD_TOKEN',
  DOCUMENT_FIELDS_UPDATED = 'DOCUMENT_FIELDS_UPDATED',
  LEASE_STATUS_MISMATCH = 'LEASE_STATUS_MISMATCH',
  NO_LEASE_ACCESS = 'NO_LEASE_ACCESS',
  SESSION_NOT_VALID = 'SESSION_NOT_VALID',
  USER_INDEX_DONT_MATCH = 'USER_INDEX_DONT_MATCH',
}

export const UserVerificationFailedReason_values = [
  UserVerificationFailedReason.BAD_TOKEN,
  UserVerificationFailedReason.DOCUMENT_FIELDS_UPDATED,
  UserVerificationFailedReason.LEASE_STATUS_MISMATCH,
  UserVerificationFailedReason.NO_LEASE_ACCESS,
  UserVerificationFailedReason.SESSION_NOT_VALID,
  UserVerificationFailedReason.USER_INDEX_DONT_MATCH,
] as const;
